import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import type { RouterClient } from "@orpc/server";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import type { AppRouter } from "@shared/rpc-types";

const rpcLink = new RPCLink({
  url: `${window.location.origin}/rpc`,
  fetch: (input, init) =>
    globalThis.fetch(input, {
      ...init,
      credentials: "include",
    }),
});

export const rpcClient: RouterClient<AppRouter> = createORPCClient(rpcLink);

export const orpc = createTanstackQueryUtils(rpcClient);
